import { api } from "../../services/api";

const path = '/password-reset.php';

/**
 * Solicita o envio do código de redefinição para o e-mail informado.
 * Por segurança, o backend responde de forma genérica (sem revelar se o e-mail existe).
 */
export async function requestCustomerResetToken(email) {
    const response = await api.get(`${path}?email=${encodeURIComponent(email)}`);
    return response.data;
}

/**
 * Verifica o código recebido por e-mail.
 */
export async function verifyCustomerResetToken(email, token) {
    const response = await api.get(
        `${path}?email=${encodeURIComponent(email)}&verification_token=${encodeURIComponent(token)}`
    );
    return response.data;
}

/**
 * Define a nova senha usando o código já verificado.
 */
export async function resetCustomerPassword(token, password) {
    const response = await api.patch(path, { verification_token: token, password });
    return response.data;
}
